import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgZincGlyph from './svgs/ZincGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var zincGlyph = (props => useIcon(SvgZincGlyph, null, props));

export { zincGlyph as default };
